export default __webpack_public_path__ + "close-thin.ce0662cd8c3918adf1038b0479f051bc.svg";